import { createModalContext, useModalState } from '@/common/app/modal'
import { ChildProps } from '@/common/util/props'

import DeleteDialog from '@/components/container/modal/dialog/delete/DeleteDialog'

interface DeleteDialogState {
  name: string
  onClickDelete(): Promise<void>
}

const defaultValue = {
  name: '',
  onClickDelete: async () => {}
}

export const DeleteDialogContext = createModalContext<DeleteDialogState>(defaultValue)

const DeleteDialogProvider = ({ children }: ChildProps) => {
  const state = useModalState<DeleteDialogState>(defaultValue)
  return (
    <DeleteDialogContext.Provider value={state}>
      {children}
      <DeleteDialog />
    </DeleteDialogContext.Provider>
  )
}

export default DeleteDialogProvider
